require("../../styles/global.scss");
require("../../js/validation-rules");

import Axios from "axios";
import Vue from "vue";
import router from "./router";
// const uuid = require("uuid/v4");
const { v4: uuid } = require("uuid");
const store = {
  finished: false,
  token: null,
  tokenValid: false,
  loading: false,
  error: null,
  id: uuid(),
};

router.beforeEach((to, from, next) => {
  console.log(`Checking token before route`);
  console.log(store.id);
  // check the token
  if (!store.token) {
    const query = window.location.search;
    const token = new URLSearchParams(query).get("token");

    if (token) {
      store.token = token;
    }
  }

  Axios.get("/check-token", { params: { token: store.token, id: store.id } })
    .then((res) => {
      const { tokenMatch, error } = res.data;
      store.tokenValid = tokenMatch;

      if (error) {
        store.error = error;
      }

      if (!store.tokenValid && to.path !== "/") {
        router.push("/");
      } else {
        next();
      }
    })
    .catch((e) => {
      console.error(e);
      if (to.path !== "/") {
        router.push("/");
      }
    });
});

const app = new Vue({
  el: "#app",
  router,
  data: {
    state: store,
  },
});
